import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { RentalService } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('entities.rentalService')

export const Gate = createGate()

const fetchRentalServices = async () => {
  const response = await RentalService.limit(50)
    .where('isEditForDriver', 'true')
    .get(1)

  return response.getData()
}
export const getRentalServices = domain.createEvent()
export const getRentalServicesFx = domain.createEffect({
  handler: fetchRentalServices,
})
export const getRentalServicesSilentFx = domain.createEffect({
  handler: fetchRentalServices,
})

export const $rentalServices = createStore<RentalService[] | null>(null)
  .on(
    [getRentalServicesFx.doneData, getRentalServicesSilentFx.doneData],
    (_, rentalServices) => rentalServices,
  )
  .on(getRentalServicesFx.failData, () => null)

sample({
  clock: Gate.open,
  source: $rentalServices,
  filter: (rentalServices) => !rentalServices,
  target: getRentalServices,
})

sample({
  clock: getRentalServices,
  target: getRentalServicesFx,
})

sample({
  clock: getRentalServicesFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: 'Ошибка получения дополнительных услуг',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})
